<template>

  <div>
    <b-container>
      <b-row class="TitleArea">
          <b-col sm="12" lg="6">
              <h1 class="heading extraPad">

                Clutch Tour  
                <template v-if="tournID == 'cpt'">Tier 1</template>
                <template v-else-if="tournID == 'cp2'">Tier 2</template>
                <template v-else-if="tournID == 'cp3'">Amateur</template>
                <template v-else-if="tournID == 'pam'">Pro-Ams</template>
                <template v-else-if="tournID == 'por'">Portugal Series</template>
                <template v-else-if="tournID == 'qsc'">Q-School</template>


              </h1>
          </b-col>
          <b-col sm="12" lg="6" class="above769" v-if="!$route.path.includes('schedule')">
              <b-link to="/schedule" class="allNewsLink">
                  <button class="Allbuttons">
                      See Full Schedule
                  </button>
              </b-link>
          </b-col>
      </b-row>
      <div class="above769">
        <b-row v-if="showFutureEvents == true ">
          <b-col lg="4" v-if="reports != '' && showTourn == true">
            <HomeTabOne
              :courseCode="course"
              :Year="season"
              :TourName="TourName"
              :TourLogo="TourLogo"
              :manyRounds="manyRounds"
              :currentReport="reportTitle"
              :currentTitle='currentTitle'
              :reportURL="currentReport"
              live='N'
              :config="config"
              match='N'
              :roundsPLayed="roundsPLayed"
              :courseDates="courseDates"
              :live_scoring="live_scoring"
              :mobName="mobName"
              :tournID="tournID"
              :tour="tournID"
              :home='true'
              :Stableford="Stableford"
            />
          </b-col>
          <template >
            <template v-if="reports != '' && showTourn == true">
              <b-col sm="12" lg="4" class="upcomingTournaments" v-for="(upComingTours, index) in FutureEventFilter.slice(0, 2)" :key="'eighteendex' + index" >
                  <div class="upcomingBlock" v-bind:style="{ 'background-image': 'url(' + fullNames[index] + ')'}">
                  </div>
                  <div class="textBlock">
                    <div class="firstUpBlock">
                      <div class="nameUpcoming">
                        {{upComingTours.full_name}} <span class="cancelled" v-if="upComingTours.cancelled == 'Y'">Cancelled</span>
                      </div>
                      <div class="datesUpcoming">
                        {{upComingTours.dic_dates}}
                      </div>
                    </div>
                    <div class="moreDetailsDiv">
                      <b-link :to="'/tournament' + '/' + upComingTours.code + '/' + Year + '?tour=' + tournID" class="detailsText">
                        <button class="moreDetails" :style="colourTour">More Details</button>
                      </b-link>
                    </div>
                  </div>
              </b-col>
            </template>
            <template v-else>
              <b-col sm="12" lg="4" class="upcomingTournaments" v-for="(upComingTours, index) in FutureEventFilter.slice(0, 3)" :key="'nineteendex' + index" >
                  <div class="upcomingBlock" v-bind:style="{ 'background-image': 'url(' + fullNames[index] + ')'}">
                  </div>
                  <div class="textBlock">
                    <div class="firstUpBlock">
                      <div class="nameUpcoming">
                        {{upComingTours.full_name}} <span class="cancelled" v-if="upComingTours.cancelled == 'Y'">Cancelled</span>
                      </div>
                      <div class="datesUpcoming">
                        {{upComingTours.dic_dates}}
                      </div>
                    </div>
                    <div class="moreDetailsDiv">
                      <b-link :to="'/tournament' + '/' + upComingTours.code + '/' + Year + '?tour=' + tournID" class="detailsText">
                        <button class="moreDetails" :style="colourTour">More Details</button>
                      </b-link>
                    </div>
                  </div>
              </b-col>
            </template>
          </template>
        </b-row>
        <b-row v-else>
          <b-col>
            <h2 class="noTournaments">No upcoming tournaments available</h2>
          </b-col>
        </b-row> 
      </div>
      <div class="below769">
        <vueper-slides 
          :touchable="true"
          class="no-shadow"
          :visible-slides="1"
          :gap="2"
          :bullets="false"
          :arrows="false"
          :autoplay="true"
          :duration="3000"
          :slide-ratio="1 / 4"
          :infinite="true"
          :dragging-distance="70"
          :pauseOnHover="false"
        >
          <vueper-slide v-if="reports != '' && showTourn == true">
            <template #content>
            <HomeTabOne
              :courseCode="course"
              :Year="season"
              :TourName="TourName"
              :TourLogo="TourLogo"
              :manyRounds="manyRounds"
              :currentReport="reportTitle"
              :currentTitle='currentTitle'
              :reportURL="currentReport"
              live='N'
              :config="config"
              match='N'
              :roundsPLayed="roundsPLayed"
              :courseDates="courseDates"
              :live_scoring="live_scoring"
              :mobName="TourName"
              :tournID="tournID"
              :tour="tournID"
              :Stableford="Stableford"
              :home='true'
            />
            </template>
          </vueper-slide>
          <vueper-slide v-for="(i, item) in FutureEventFilter.slice(0,3)" :key="'twentydex' + item" :title="i.toString()" >
            <template #content>
            <div class="upcomingBlock" v-bind:style="{ 'background-image': 'url(' + fullNames[item] + ')'}">
            </div>
            <div class="textBlock">
              <div class="firstUpBlock">
                <div class="nameUpcoming">
                  {{i.full_name}} <span class="cancelled" v-if="i.cancelled == 'Y'">Cancelled</span>
                </div>
                <div class="datesUpcoming">
                  {{i.dic_dates}}
                </div>
              </div>
              <div class="moreDetailsDivMob">
                <b-link :to="'/tournament' + '/' + i.code + '/' + Year + '?tour=' + tournID" class="detailsText">
                  <button class="moreDetails" :style="colourTour">More Details</button>
                </b-link>
              </div>
            </div>
            </template>
          </vueper-slide>
        </vueper-slides>
      </div>
    </b-container>
  </div>
</template>

<script>
import HomeTabOne from "@/components/homeTabOne.vue";
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import apiCall from "@/services/api.js";
export default {
  name: "Upcoming Tournaments",
  props: ["Year", "config", "DEFIMAGESAMS3", "tournID", "code"],
  components: {
    VueperSlides, 
    VueperSlide,
    HomeTabOne
  },
  data() {
    return {
      sliding: false,
      imgURL: this.config.VUE_APP_COURSE_URL,
      file: "File_1.jpg",
      upComingTours: [],
      img: this.config.VUE_APP_DEFAULT_COURSE,
      tournImage: '',
      showFutureEvents: '',
      tm_params: [],
      reports: [],
      course: [],
      season: [],
      roundsPLayed: '',
      imageCode: '',
      tournDates: '',
      TourName: '',
      manyRounds: '',
      course_name: '',
      courseDates: '',
      live_scoring: '',
      mobName: '',
      tourlogo:'',
      singleTours: '',
      noTours: '',
      Stableford: '',
      showTourn: '',
      bkImage: ''
    };
  },
  computed: {
    FutureEventFilter: function() {
      console.log('in future events')
      return this.upComingTours.filter(
        (upComingTours) => upComingTours.days_away > 3
      );
    },
    slidesTotal:function(){
      return this.FutureEventFilter.length
    },
    // corrections start
    fullNames: function() {
        var Year = this.Year
        return this.FutureEventFilter.map(function(item) {
          if (item.course_image_file_1 == '') {
            console.log('blank')
            return 'https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/tourninfo.png'
          } else {
            console.log('not blank')
            return 'https://tms-images.ams3.cdn.digitaloceanspaces.com/cpt/courses/' + Year + '/' + item.course_code + '/' + item.course_image_file_1
          }
        });
    },
    colourTour: function() {
      var backgroundColourTour = '';
      if (this.tournID == 'cpt') {
        backgroundColourTour = 'background-color: #bceff0'
      } else if (this.tournID == 'cp2') {
        backgroundColourTour = 'background-color: #bde9d8'
      } else if (this.tournID == 'cp3') {
        backgroundColourTour = 'background-color: #dfc3c2;color: #081C3F'
      } else if (this.tournID == 'pam') {
        backgroundColourTour = "background-color: #c3bcce;color: #081C3F"
      } else if (this.tournID == 'qsc') {
        backgroundColourTour = 'background-color: #ededc3'
      } else if (this.tournID == 'por') {
        backgroundColourTour = 'background-color: #c96b6b;color: #ffff'
      }
      return backgroundColourTour
    },
    ReportcolourTour: function() {
      var backgroundColourTour = '';
      if (this.tour == 'cpt') {
        backgroundColourTour = 'background-color: #bceff0; color:#081C3F'
      } else if (this.tour== 'cp2') {
        backgroundColourTour = 'background-color: #bde9d8; color:#081C3F'
      } else if (this.tour == 'cp3') {
        backgroundColourTour = 'background-color: #dfc3c2;color: #081C3F'
      } else if (this.tour == 'pam') {
        backgroundColourTour = 'background-color: #c3bcce;color: #081C3F'
      } else if (this.tour == 'qsc') {
        backgroundColourTour = 'background-color: #ededc3'
      }else if (this.tour == 'por') {
        backgroundColourTour = 'background-color: #c96b6b;color: #ffff'
      }
      return backgroundColourTour
    },
    filterReports: function() {
        if (Array.isArray(this.reports)) {
          return this.reports.filter(
            (reports_entry) =>
              reports_entry.report_title.includes("Tournament Entries") ||
              reports_entry.report_title.includes("Score") ||
              // reports_entry.report_title.includes("Draw") ||
              reports_entry.report_title.includes("Final")
          );
        } else return this.reports; 
    },
    currentReport: function() {
      if (Array.isArray(this.filterReports))
        return this.filterReports[this.filterReports.length - 1].report_url;
      else return this.filterReports.report_url;
    },
    currentTitle: function() {
      if (Array.isArray(this.filterReports))
        return this.filterReports[this.filterReports.length - 1].report_title;
      else return this.filterReports.report_title;
    },
    reportTitle: function(url) {
        if (
          this.currentReport.indexOf("tmentry") !== -1
        ) {
          url =
            this.config.VUE_APP_API +
            this.config.VUE_APP_ID +
            "/cache/" +
            this.tournID +
            "/" +
            this.season +
            "/" +
            this.season +
            "-" +
            this.course +
            "-entryw-entries.json?randomadd=" +
            new Date().getTime();
        } else if(this.currentReport.indexOf("tmentry") !== -1) {
        url =
            this.config.VUE_APP_API +
            this.config.VUE_APP_ID +
            "/cache/" +
            this.tournID +
            "/" +
            this.season +
            "/" +
            this.season +
            "-" +
            this.course +
          "-entry-entries.json?randomadd=" +
          new Date().getTime();
        } else if(this.currentReport.indexOf("tmdraw") !== -1) {
          var subRep = this.currentReport.lastIndexOf("round=") + 6;
          var indNext = this.currentReport.indexOf("~", subRep);
          var drawRnd = this.currentReport.substr(subRep, indNext - subRep);
          url =
            this.config.VUE_APP_API +
            this.config.VUE_APP_ID +
            "/cache/" +
            this.tournID +
            "/" +
            this.season +
            "/" +
            this.season +
            "-" +
            this.course +
            "-" +
            "draw" +
            "-" +
            'R'+drawRnd
            +
            "-draw.json?randomadd=" +
            new Date().getTime();
        } else {
          if (this.currentReport.indexOf("tmscores") !== -1) {
            var subRep2 = this.currentReport.lastIndexOf("params=") + 7;
            var indNext2 = this.currentReport.indexOf("~", subRep2);
            var repParams = this.currentReport.substr(
              subRep2,
              indNext2 - subRep2
            );
            if (repParams && repParams.indexOf(".cgi") < 0) {
              url =
                this.config.VUE_APP_API +
                this.config.VUE_APP_ID +
                "/cache/" +
                this.tournID +
                "/" +
                this.season +
                "/" +
                this.season +
                "-" +
                this.course +
                "-scores-" +
                repParams +
                ".json" +
                "?randomadd=" +
                new Date().getTime();
            } else {
              url =
                this.config.VUE_APP_API +
                this.config.VUE_APP_ID +
                "/cache/" +
                this.tournID +
                "/" +
                this.season +
                "/" +
                this.season +
                "-" +
                this.course +
                "-scores-latest.json" +
                "?gt=y&randomadd=" +
                new Date().getTime();
            }
          } else if (this.currentReport.indexOf("tmlsmon") !== -1) {
            {
              url =
                this.config.VUE_APP_API +
                this.config.VUE_APP_ID +
                "/cache/" +
                this.tournID +
                "/" +
                this.season +
                "/" +
                this.season +
                "-" +
                this.course +
                "-scores-latest.json" +
                "?gt=y&randomadd=" +
                new Date().getTime();
            }
          } else if (this.currentReport.indexOf("tmstats") !== -1) {
            {
              url =
                this.config.VUE_APP_API +
                this.config.VUE_APP_ID +
                "/cache/" +
                this.tournID +
                "/" +
                this.season +
                "/" +
                this.season +
                "-" +
                this.course +
                "-scores-latest.json" +
                "?gt=y&randomadd=" +
                new Date().getTime();
            }
          } else if (this.currentReport.indexOf("tmcrsts") !== -1) {
            {
              url =
                this.config.VUE_APP_API +
                this.config.VUE_APP_ID +
                "/cache/" +
                this.tournID +
                "/" +
                this.season +
                "/" +
                this.season +
                "-" +
                this.course +
                "-scores-latest.json" +
                "?gt=y&randomadd=" +
                new Date().getTime();
            }
          } else if (this.currentReport.indexOf("tmresult") !== -1) {
            var subRep1 = this.currentReport.lastIndexOf("result=") + 7;
            var indNext1 = this.currentReport.indexOf("~", subRep1);
            var resNum1 = this.currentReport.substr(subRep1, indNext1 - subRep1);
            console.log("resNum === ");
            console.log(resNum1);
            url =
              this.config.VUE_APP_API +
              this.config.VUE_APP_ID +
              "/cache/" +
              this.tournID +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-result-result-" +
              resNum1 +
              ".json" +
              "?randomadd=" +
              new Date().getTime();
          } else {
            url =
              this.config.VUE_APP_API +
              this.config.VUE_APP_ID +
              "/cache/" +
              this.tournID +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-result-result-PF.json" +
              "?randomadd=" +
              new Date().getTime();
          }
        } 
      return url;
    },
    // corrections end
  },
  methods: {
    replaceByDefault(e) {
      e.target.src = this.img;
    },
    checkForTourns : function() {
      if (this.FutureEventFilter.length > 0) {
        console.log('More then one event')
        this.showFutureEvents = true
      } else {
        console.log('There are no events')
        this.showFutureEvents = false
      }
    },
    getMiniTour : function() {
      console.log('Inside miniTour')
      apiCall
        .tmParamsBaseSchedule(this.tournID)
        .then(({ data }) => {
          console.log('Inside miniTour - inside')
          this.tm_params = data;
          if (this.tm_params.days_away > -6 && this.tm_params.days_away < 4) {
            this.showTourn = true;
            console.log('in true')
          } else {
            this.showTourn = false;
            console.log('in false')
          }
          this.reports = data.reports.reports_entry;
          console.log("this.reports")
          console.log( this.reports)
          this.season = data.tm_params.season_code;
          console.log("this.season")
          console.log( this.season)
          this.course = data.code;
          console.log("this.course")
          console.log( this.course)
          this.roundsPLayed = data.rounds_played;
          this.manyRounds = data.rounds;
          console.log("this.manyRounds")
          console.log(this.manyRounds)
          this.Stableford = data.stableford;
          this.mobName = data.short_name
          this.course_name = data.course_name;
          this.live_scoring = data.live_scoring;
          console.log("live" + this.live_scoring)
          this.TourLogo = data.sponsor_logo;
          console.log("logo" + this.TourLogo)
          this.bkImage = data.course_image_file_1;
          if (data.use_full_name == 'N') {
            this.TourName = data.short_name;
          } else {
            this.TourName = data.full_name;
          }
          // this.DEFIMAGESAMS3 = data.tm_params.DEFIMAGESAMS3;
          // console.log("this.roundsPLayed")
          // console.log(this.roundsPLayed)
          // this.tourlogo = data.sponsor_logo;
          // console.log("this.tourlogo")
          // console.log(this.tourlogo)
          // this.bkImage = data.course_image_file_1;
          // this.imageCode = data.course_code;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          throw error;
        });
      }
  },
  created() {
    apiCall
      .upComing(this.Year, this.tournID)
      .then(({ data }) => {
        if (Array.isArray(data.tournaments.tournaments_entry)) {
           this.upComingTours = data.tournaments.tournaments_entry;
          // console.log('One')
        } else {
           this.upComingTours = [data.tournaments.tournaments_entry]
          // console.log('Two')
        }
        // this.upComingTours = data.tournaments.tournaments_entry;
        this.singleTours = data.tournaments.tournaments_entry;
        this.noTours = data.tournaments;
        // this.TournamentBKimage();
        this.checkForTourns();
        this.getMiniTour();
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
  },
};
</script>

<style scoped>
.cancelled {
  background-color: #C8112E;
  color: #fff;
  padding: 5px;
  font-size: 15px;
  position: relative;
  top: -3px;
}
::v-deep td.MTest.mobNone.\31 {
    display: none;
}
::v-deep td.MTest.mobNone.\32 {
    display: none;
}
::v-deep td.MTest.mobNone.\33 {
    display: none;
}
::v-deep li.Flisting-btn > a {
    color: #fff;
    font-size: 18px;
    padding-top: 10px;
    padding-bottom: 10px;
    /* font-weight: bold !important; */
    /* border: 1px solid #00FFFE; */
    /* background-color: #00FFFE; */
    /* border-radius: 30px; */
    /* font-weight: bold !important; */
    background-color: #081C3F;
    position: relative;
    bottom: 12px;
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border-radius: 26px;
}
::v-deep li.nav-item.Flisting-btn.right{
    width: 100%;
    text-align: center;
    padding-left: 24px;
    padding-right: 24px;
    /* margin-bottom: 4px; */
    margin-bottom: 4px;
    margin-top: 4px;
}
::v-deep div#entries {
  /* height: 400px; */
  height: 435px!important;
  display: block;
  overflow: scroll;
  background-color: #fff;
}
::v-deep div#score {
  /* height: 400px; */
  height: 435px!important;
  display: block;
  overflow: scroll;
  background-color: #fff;
}
::v-deep div#Results {
  /* height: 400px; */
  height: 435px!important;
  display: block;
  overflow: scroll;
  background-color: #fff;
}
::v-deep .WidgetTop-Section{
  color: white;
  padding: 20px;
  background-color: #081C3F;
  padding-bottom: 10px;
  padding-top: 10px;
  height: 109px!important;
}
 a.detailsText:hover {
  color: #081C3F;
 }
.entiesClosedSec {
  position: absolute;
  bottom: 0;
  font-size: 14px;
  padding-left: 6px;
  padding-bottom: 8px;
}
a.allNewsLink {
  text-decoration: none!important;
}
.mobSchedBut {
  position: relative;
  top: 10px;
}
.vueperslides {
  position: relative;
  height: 600px;
}
::v-deep .vueperslides__parallax-wrapper {
  position: relative;
  overflow: initial!important;
  height: 600px;
}
.upcomingTournaments:hover {
  transform: translateY(-10px);
}

.upcomingTournaments {
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
}
.firstUpBlock {
  padding-top: 3em;
  padding-left: 10px;
  padding-right: 10px;
}
::v-deep a.detailsText {
  text-decoration: none;
  color: #081C3F;
}
a.detailsText:hover > button{
  /* color: #fff!important; */
  text-decoration: none!important;
}
.moreDetailsDiv {
  margin: auto;
  background-color: transparent;
  text-decoration: none!important;
  bottom: 55px;
  left: 0;
  right: 0;
  position: absolute;
  width: 206px;
  height: 52px;
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border-radius: 26px;
}
.moreDetailsDiv:hover {
  width: 206px;
  height: 52px;
  margin: auto;
  background-color: #1FFFA5;
  color: #081C3F!important;
  text-decoration: none;
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border-radius: 26px;
}
.moreDetails {
  border: none;
  display: block;
  margin: auto;
  /* background-color: #00FFFE; */
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 16px;
  color: #081C3F;
  width: 206px;
  height: 52px;
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border-radius: 26px;
}
.moreDetails:hover {
  border: none;
  display: block;
  margin: auto;
  background-color: #081C3F!important;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 16px;
  color: #fff!important;
  width: 206px;
  height: 52px;
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  background: #081C3F!important;
  border-radius: 26px;
}
h2.noTournaments {
  text-align: center;
  display: block;
  font-size: 36px;
  color: #081C3F;
  margin: auto;
}
.datesUpcoming {
  color: #081C3F;
  font-size: 24px;
  font-weight: 500;
  text-align: center;
}
.nameUpcoming {
  color: #081C3F;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}
.upcomingBlock {
  /* height: 500px; */
  height: 304px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  /* margin-right: 20px; */
  background-color: black;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.textBlock{
  background-color: #fff;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  height: 304px;
  border: 0px solid #E0E0E0;
}
.TitleArea {
  padding-bottom: 30px;
}
.paddingSpace {
  padding: 50px;
}
.Allbuttons {
  float: right;
  width: 244px;
  height: 50px;
  background: transparent;
  color: #081C3F;
  /* font-weight: 500; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border-radius: 30px;
  border: 1px solid #081C3F;
  font-size: 16px;
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
}
.Allbuttons:hover {
  float: right;
  width: 244px;
  height: 50px;
  background: #081C3F;
  color: #fff;
  /* font-weight: 500; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border-radius: 30px;
  border: 1px solid #E8E8E8;
  transform: translateY(-10px);
}
h1.heading.extraPad {
  /* padding: 20px; */
}
.heading{
  /* font-weight: 600; */
  font-size: 36px;
  color: #081C3F;
  padding-bottom: 10px;
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
}
::v-deep .bslide > .slick-list > .slick-track > .slick-slide {
  width: 100%!important;
  display: contents;
}
.sponLogo {
  /* background: #fff; */
  /* padding: 40px; */
  /* margin-right: 20px; */
}
p.moreInfo-btn.tournlink {
  background-color: #081C3F;
  width: 200px;
  text-align: center;
  color: #fff;
  /* border-radius: 10px; */
  padding: 0.5rem 1rem;
}
::v-deep .bslide > .slick-list > .slick-track > .slick-slide {
  width: 100%!important;
}
::v-deep .bslide > .slick-list > .slick-track{
  display: flex;
  overflow: scroll;
  width: 100%!important;
  height: inherit;
}
::v-deep a {
  color: black;
}
img.logo {
  max-width: 136px;
  float: right;
  padding-right: 45px;
  margin-top: -100px;
}

.courseImg {
  width: 100%;
}
::v-deep .slick-slider > button {
  display: none !important;
}
.backImg {
  background-repeat: no-repeat !important;
  background-size: cover !important;
  height: 415px !important;
}
.minibackImg {
  background-color: lightgrey;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  height: 76px;
}
::v-deep .slick-slide > div > div > img {
  opacity: 0.5;
}
::v-deep .slick-current > div > div > img {
  opacity: 1;
}
.cap {
  position: absolute;
  color: white;
  padding-left: 4%;
  text-align: left;
  color: #ffffff;
  background-color: rgba(38, 48, 86, 0.7);
  top: -300px;
  padding-top: 20px;
  height: 225px;
  left: 15px;
  right: 58%;
}
::v-deep .slick-list {
  position: relative;
  display: block;
  margin: 0;
  padding: 0;
  transform: translateZ(0);
  box-shadow: 0 1px 4px rgb(0 0 0 / 20%);
}
::v-deep .bslide > .slick-list {
  height: 150px;
}

.tourName {
  font-size: 14px;
  color: #081C3F;
  margin-bottom: 2px;
  padding-left: 10px;
  padding-right: 10px;
  white-space: nowrap;
  width: 175px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
.tourNameTwo {
  color: #d3d3d3;
  white-space: nowrap;
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
.mobile {
  display: none;
}

@media only screen and (max-width: 1200px) {
  .upcomingBlock:before {
    content: "";
    position: absolute;
    overflow: hidden;
    /* border-radius: 50px; */
    width: 91%;
    height: 50%;
    bottom: 0;
    /* background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.4)); */
    border-bottom-left-radius: 50px;
    border-bottom-right-radius: 50px;
  }
}
@media only screen and (max-width: 1281px) {
  img.logo {
    max-width: 136px;
    float: right;
    padding-right: 45px;
    margin-top: -100px;
  }
}
@media only screen and (max-width: 990px) {
  .upcomingTournaments.col-sm-12.col-lg-4 {
    margin-bottom: 30px;
  }
  ::v-deep li.nav-item.Flisting-btn.right{
      width: 100%;
      text-align: center;
      padding-left: 24px;
      padding-right: 24px;
      /* margin-bottom: 4px; */
      margin-bottom: 4px;
      margin-top: 14px;
  }
}
@media only screen and (max-width: 900px) {
  ::v-deep li.Flisting-btn > a {
    font-size: 16px;
    position: relative;
    bottom: 25px;
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border-radius: 26px;
  }
  .upcomingTournaments {
    padding-top: 15px;
  }
  #slider {
    display: none;
  }
  .mobile {
    display: block;
    padding: 20px 0;
  }
  ::v-deep .mobCap > .carousel-caption {
    bottom: 0px;
    background-color: rgba(38, 48, 86, 0.7);
    margin: auto;
  }
  ::v-deep .img-fluid {
    height: 180px;
  }
  ::v-deep .mobCap > .carousel-caption > a{
    color:#fff!important;
  }
  .heading {
    /* font-weight: 600; */
    font-size: 36px;
    color: #081C3F;
    text-align: left;
    margin-top: 0px;
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
  }
  /* .Allbuttons {
    float: none;
    width: 244px;
    height: 50px;
    background: transparent;
    color: #081C3F;
    font-weight: 500;
    border-radius: 30px;
    border: 1px solid #E8E8E8;
    margin: auto;
    display: block;
    margin-top: 30px;
  } */
}
@media only screen and (max-width: 500px) {
  ::v-deep .img-fluid {
    height: 130px;
  }
  ::v-deep .mobCap > .carousel-caption{
    bottom:10px;
  }
  .upcomingBlock:before {
    content: "";
    position: absolute;
    overflow: hidden;
    /* border-radius: 50px; */
    width: 94%!important;
    height: 50%;
    bottom: 0;
    /* background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.4)); */
    border-bottom-left-radius: 50px;
    border-bottom-right-radius: 50px;
  }
}
@media only screen and (min-width: 769px) {
  .below769 {
    display: none;
  }
}
@media only screen and (max-width: 769px) {
  .above769 {
    display: none;
  }
  .moreDetailsDivMob {
    width: 206px;
    margin: auto;
    background-color: #00FFFE;
    text-decoration: none !important;
    left: 0;
    right: 0;
    position: relative;
    top: 40px;
    color: #081C3F;
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border-radius: 26px;
  }
  .moreDetailsDivMob:hover {
    width: 206px;
    margin: auto;
    background-color: #1FFFA5;
    text-decoration: none !important;
    left: 0;
    right: 0;
    position: relative;
    top: 40px;
    color: #081C3F;
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border-radius: 26px;
  }
  .firstUpBlock {
    padding-top: 4em;
    padding-left: 50px;
    padding-right: 50px;
  }
}
@media only screen and (max-width: 510px) {
  .nameUpcoming {
    color: #081C3F;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }
  .datesUpcoming {
    color: #081C3F;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }
}
</style>
